function save_pincode(){
  var pincode = $('.pincode-input').val();
  localStorage.setItem("pincode", pincode);
  $('.inner-in input').val(localStorage.getItem("pincode"));
}

function before_deliverable_check() {
  if ($(".pincode-input").val() != "") {
    is_deliverable();
  } else {
    $('#deliverable').hide();
    $('#delivery-sucess').hide();
  }
}

function is_deliverable(){
  if ($(".pincode-input").val() != "") {
    $.ajax({
      type: "GET",
      url: "/deliverable",
      data: {
        zipcode: $(".pincode-input").val(),
      },
      success: function (result) {
        if (result.available == true) {
          $('#deliverable').hide();
          $('#delivery-sucess').show();
          $('#add-to-cart-button').show(); 
        } else {
          $('#deliverable').show();
          $('#delivery-sucess').hide();
          $('#add-to-cart-button').hide();
        }
      },
    });
  } else {
    $('#deliverable').hide();
  }
}

function availabe_product(){
  col = $('.select-label.full').parent().children().first().prop("disabled");
  if (col){
    $('#buy-btn').css("pointer-events", "none").css("color", "#d2d2d2");
    $('#rent-btn').click();
  }
  else{
    $('#buy-btn').css("pointer-events", "unset").css("color", "#777");
  }
}

$(document).ready(function(){
  $('#delivery-sucess').hide();

  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });

  $('.select-label').click(function() {
    $('.duration-title').hide(300);
  })

  $('.pincode-input').val(localStorage.getItem("pincode"));

  if ($(".pincode-input").val() != "") {
    is_deliverable();
  } else {
    $('#deliverable').hide();
  }

  availabe_product();

  $('#rent-btn').click(function(){
    $(this).addClass('active');
    $('#buy-btn').removeClass('active');
    $('.rent-btn-parent p').removeClass('d-none');
    $('.renting-duration').removeClass('d-none');
    $('.renting-duration li:first input, .renting-duration li:first label').click();
  })

  $('#buy-btn').click(function(){
    $(this).addClass('active');
    $('#rent-btn').removeClass('active');
    $('.rent-btn-parent p').addClass('d-none');
    $('.renting-duration').addClass('d-none');
    $('.product-variants-variant-values li.full input').click();
  })

  $('.product-variants-variant-values li label').on("click", function(){
    $('.product-variants-variant-values li label').removeClass('active');
    $(this).addClass('active');
  })

  $('.color-available').on('change', function(){
    availabe_product();
  });

  if (localStorage.getItem("source_url") == "/products" || localStorage.getItem("source_url") == "/" || localStorage.getItem("source_url") == "/t/featured" ){
    col = $('.select-label.full').parent().children().first().prop("disabled");
    if (col == false){
      $('#buy-btn').click();
    }
  }else{
    $('.renting-duration li:first input, .renting-duration li:first label').click();
  }

  $("#check-delivery").on('click', function(){
    save_pincode();
    before_deliverable_check();
  });

  $(".pincode-input").on('change', function(){
    before_deliverable_check();
  });
})


$('#quotation-modal').click(function(){
  $('#quotation-source-url').val($('#quotation-modal').data('id'));
});
